(function(angular) {
    'use strict';

    angular.module('profiles')
    .factory('profileHelper', ['utilService', 'channelsProvider', 'moment','customChannels', function (utilService, channelsProvider, moment, customChannels) {
        var _schema = [];
        var _allowOtherProperties = false;
        var _profile = {};
        var  _availableChannels = {
            "sms": {
                "label": "SMS",
                "property": "generalProperties.phoneNumber",
                "logo": "./assets/img/icons/sms_icon.png",
                "smallLogo": "./assets/img/icons/sms_solid.svg",
            },
            "mms": {
                "label": "MMS",
                "property": "generalProperties.phoneNumber",
                "logo": "./assets/img/icons/sms_icon.png",
                "smallLogo": "./assets/img/icons/sms_solid.svg",
            },
            "fbMessenger": {
                "label": "Messenger",
                "property": "facebook.fbMessengerId",
                "logo": "./assets/img/icons/messenger_logo.png",
            },
            "appMessaging": {
                "label": "App Messaging",
                "property": "generalProperties._devices",
                "logo": "./assets/img/icons/syg.png",
            },
            "email": {
                "label": "Email",
                "property": "generalProperties.email",
                "logo": "./assets/img/icons/mail_icon.png",
            },
            "twitterDm": {
                "label": "Twitter",
                "property": "twitter.twitterId",
            },
            "whatsApp": {
                "label": "WhatsApp",
                "property": "whatsApp.whatsAppId",
            },
            "rcs": {
                "label": "RCS",
                "property": "generalProperties.phoneNumber",
            },
            "nativePush": {
                "label": "Native Push",
                "property": "generalProperties._devices",
            },
        };
        var availableChannels;
        function stripLabel(value) {
            if (typeof value != 'string') {
                return value;
            }
            if (value.includes('-')) {
                return value.replace(/-/g, ' ').toLowerCase();
            }
            else if (value.includes('.')) {
                return value.replace(/\./g, ' ').toLowerCase();
            }
            else if (value.includes('_')) {
                return value.replace(/_/g, ' ').toLowerCase();
            }
            else {
                return value.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
            }
        }

        function predictType(value){
            if(typeof value === 'object'){
                return 'object';
            }
            if(typeof value === 'boolean' || (value && typeof value === "string" && (value.toLowerCase() == 'true' || value.toLowerCase() == 'false'))){
                return 'boolean';
            }
            else if(typeof value !== 'boolean' && !value){
                return "string";
            }
            
            if(typeof value == 'number'){
                return 'number';
            }
            var date = value.split('-');
            value = value.toLowerCase();
            if(date.length > 2 && date[0].length == 4 && date[1].length == 2 && date[2].length == 5){
                return "date";
            }
            else if(value.includes('http')){
                if(value.includes('.jpg') || value.includes('.png') || value.includes('.gif')){
                    return "image";
                }
                return "link";
            }
            return "string";
        }


        function validProperty(property){
            return property || (typeof property === "boolean" && property === false);
        }

        function trim(string) {
            return string.trim().replace(/ /g, "_");
        }

        var fac = {
            stripLabel: stripLabel,
            predictType: predictType,
            getCriteria: function(criteria){
                    var arrays = {};
                    var properties = [];
                    criteria = criteria.split('&');
                    for (var crit in criteria) {
                        var addedToArray = false;
                        var separatedCrit = criteria[crit].split('=');
                        var selector = separatedCrit[0];
                        var logic = "=";
                        var value;
                        var day;
                        var hours;
                        if (separatedCrit[1].length === 0 && separatedCrit[0].charAt(separatedCrit[0].length-2) != '[' && separatedCrit[0].charAt(separatedCrit[0].length-1) != ']') {
                            logic = logic + '=';
                            value = '';
                        }
                        else if (separatedCrit[0].charAt(separatedCrit[0].length-2) == '[' && separatedCrit[0].charAt(separatedCrit[0].length-1) == ']') {
                            selector = selector.slice(0, -2);
                            value = '';
                            if(!arrays[selector]){
                                arrays[selector] = {};
                                arrays[selector].value = separatedCrit[1];
                            }
                            else{
                                arrays[selector].value = arrays[selector].value + ', ' + separatedCrit[1];
                            }
                            addedToArray = true;
                        }
                        else if (separatedCrit[1].charAt(0) == '!' && separatedCrit[1].length == 1) {
                            logic = logic + '=!';
                            value = '';
                        }
                        else {
                            if (['~', '^', '<', '>', '!', '$'].indexOf(separatedCrit[1].charAt(0)) >= 0) {
                                logic = '=' + separatedCrit[1].charAt(0);
                                if (separatedCrit[1].charAt(1) == '^') {
                                    logic = logic + separatedCrit[1].charAt(1);
                                    value = separatedCrit[1].slice(2, -1);
                                }
                                else {
                                    value = separatedCrit[1].substring(1);
                                }
                            }
                            else {
                                value = separatedCrit[1];
                            }
                        }
                        if (value.match(/(\d{4})-(\d{2})-(\d{2})(.*)/)) {
                            day = new Date(value);
                            if (value.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2})\:(\d{2})(.*)/)) {
                                if (value.indexOf('000Z') == -1) {
                                    value = value + ':00.000Z';
                                }
                                day = new Date(value);
                                hours = ('00' + day.getHours()).slice(-2) + ":" + ('00' + day.getMinutes()).slice(-2);
                            }
                            value = '';
                        } else {
                            value = decodeURIComponent(value);
                        }
                        var propertyName = _schema.filter(function(singleProperty){
                            return singleProperty.path == selector;
                        });
                        var realSelector = selector;
                        selector = propertyName[0] ? propertyName[0].name : selector;
                        if ((logic == "=" || logic == "=<" || logic == "=>") && selector && (value.startsWith('\'') && value.charAt(value.length - 1) == '\'')) {
                            value = value.slice(1, -1);
                        }
                        if(!addedToArray){
                            properties.push({
                                selector: selector,
                                logic: logic,
                                value: value,
                                day: day,
                                hours: hours
                            });
                            fac.checkSelector(properties[properties.length - 1]);
                        }
                        else{
                            if(properties.filter(function(property){
                                return property.selector == selector;
                            }).length === 0){
                                properties.push({
                                    selector: selector,
                                    logic: '[]='
                                });
                                fac.checkSelector(properties[properties.length - 1]);
                            }
                            arrays[realSelector].index = properties.length - 1;
                        }
                    }
                    for(var selector in arrays){
                        properties[arrays[selector].index].value = decodeURIComponent(arrays[selector].value);
                    }
                    return properties;
            },
            checkSelector: function (property) {
                var check = false;
                for (var index in _schema) {
                    var singlePropertySchema = _schema[index];
                    if (singlePropertySchema.name == property.selector) {
                        property.onlyBooleans = false;
                        
                        if (singlePropertySchema.type == "object") {
                            property.onlyObjects = true;
                            property.tooltip = property.selector + ' is an ' + utilService.translateFieldType(singlePropertySchema.type);
                            property.logic = "==";
                            property.placeholder = "";
                            delete property.day;
                            delete property.hours;
                        }
                        else if (singlePropertySchema.type == 'date') {
                            property.onlyDates = true;
                            property.tooltip = property.selector + ' is a ' + utilService.translateFieldType(singlePropertySchema.type);
                            if (property.logic != '=~' && property.logic != '=<' && property.logic != '=>') {
                                property.logic = '=~';
                                delete property.value;
                            }
                        }
                        else {
                            if(singlePropertySchema.type == 'boolean'){
                                property.onlyBooleans = true;
                                property.logic = "=";
                            }
                            else if(property.logic == "="){
                                property.logic = "=~^";
                            }
                            var tooltip = '';
                            property.placeholder = "";
                            tooltip = property.selector + ' is a ' + utilService.translateFieldType(singlePropertySchema.type);
                            if(singlePropertySchema.examples && singlePropertySchema.examples.length){
                                tooltip = tooltip + '.<br> Sample values from your data: ';
                                for (var i in singlePropertySchema.examples.slice(0, 3)) {
                                    tooltip = tooltip + singlePropertySchema.examples[i];
                                    if (i < singlePropertySchema.examples.length && i < 2) {
                                        tooltip = tooltip + ', ';
                                    }
                                }
                                property.placeholder = "E.g. " + singlePropertySchema.examples[0];
                            }
                            property.tooltip = tooltip;

                            property.onlyObjects = false;
                            property.onlyDates = false;
                            delete property.day;
                            delete property.hours;
                        }
                        check = true;
                        break;
                    }
                }
                if (!check) {
                    delete property.tooltip;
                    delete property.onlyObjects;
                    delete property.type;
                    delete property.onlyDates;
                    property.placeholder = "Enter a value";
                }
                if(property.logic == '[]='){
                    property.placeholder = "Enter comma separated values";
                }
            },
            getExtension: function(properties){
                var extension = '';
                var selector;
                for (var property in properties) {
                    var arrayFound = false;
                    var inArray = '';
                    var isDate = false;
                    var propertyName = _schema.filter(function(singleProperty){
                        return singleProperty.name == properties[property].selector;
                    });
                    selector = propertyName[0] ? propertyName[0].path : properties[property].selector;
                    if (!properties[property].value && properties[property].day) {
                        isDate = true;
                        if (properties[property].hours) {
                            properties[property].day.setHours(properties[property].hours.split(':')[0], properties[property].hours.split(':')[1]);
                            properties[property].value = properties[property].day.toISOString();

                        }
                        else {
                            if (properties[property].logic == '=>') {
                                properties[property].day.setHours(23, 59);
                            }
                            else if (properties[property].logic == '=~') {
                                properties[property].day.setHours(12, 0);
                            }
                            else {
                                properties[property].day.setHours(0, 0);
                            }
                            properties[property].value = properties[property].day.toISOString();
                        }
                        if (properties[property].logic == '=~') {
                            if (properties[property].hours) {
                                properties[property].value = properties[property].value.split('T')[0] + 'T' + properties[property].value.split('T')[1].substring(0, 5);
                            }
                            else {
                                properties[property].value = properties[property].value.split('T')[0];
                            }
                        }
                    }
                    if (selector) {
                        properties[property].value = isDate ? properties[property].value : encodeURIComponent(properties[property].value)
                        var logic;
                        switch (properties[property].logic) {
                            case '==':
                                logic = '=';
                                properties[property].value = '';
                                properties[property].day = '';
                                properties[property].hours = '';
                                break;
                            case '==!':
                                logic = '=!';
                                properties[property].value = '';
                                properties[property].day = '';
                                properties[property].hours = '';
                                break;
                            case '=~^':
                                logic = '=~^';
                                if (!properties[property].value) {
                                    logic = '=';
                                    properties[property].day = '';
                                    properties[property].hours = '';
                                }
                                else {
                                    properties[property].value = properties[property].value + '$';
                                }
                                break;
                            case '[]=':
                                properties[property].value = decodeURIComponent(properties[property].value)
                                logic = '[]=';
                                arrayFound = true;
                                var splitArray = properties[property].value.split(',');
                                for(var i in splitArray){
                                    if(inArray !== ''){
                                        inArray = inArray + '&';
                                    }
                                    inArray = inArray + selector + logic + encodeURIComponent(splitArray[i].trim());
                                }
                                break;
                            default:
                                logic = properties[property].logic;
                                break;
                        }
                        if (extension !== '') {
                            extension = extension + '&';
                        }
                        var obj = _schema.filter(function (obj) {
                            return obj.path === selector;
                        });

                        if(arrayFound){
                            extension = extension + inArray;
                        }
                        else{
                            if (obj[0] && obj[0].type == 'String' && (properties[property].logic == '=' || properties[property].logic == '=>' || properties[property].logic == '=<') && /^\d+$/.test(properties[property].value)) properties[property].value = "'" + properties[property].value + "'";
                            extension = extension + selector + logic + properties[property].value;
                        }
                    }
                }
                return extension;
            },
            getSchema: function(){
                return _schema;
            },
            allowOtherProperties: function(){
                return _allowOtherProperties;
            },
            getProfile: function(){
                return _profile;
            },
            getAvailableChannels: function(){
                if(!availableChannels){
                    fac.setAvailableChannels();
                }
                return availableChannels;
            },
            setSchema: function(profileSchema){ 
                _schema = profileSchema.fields.filter((singleProperty) => {
                    if(singleProperty.path.includes(".")){
                        var possibleChannel = singleProperty.path.split(".")[0]
                        if(channelsProvider[possibleChannel] && !channelsProvider[possibleChannel].allowed){
                            return false;
                        }
                    }
                    return true;
                });
                _allowOtherProperties = profileSchema._allowOtherProperties;
                return _schema;
            },
            setAvailableChannels: function () {
                availableChannels = angular.copy(_availableChannels);
                if (customChannels.data && customChannels.data.length > 0) {
                    
                    customChannels.data.forEach(chan => {
                        availableChannels[chan.id] = {
                            "label": chan.name,
                            "property":"generalProperties.profileId"
                        };
                    })
                }

                for (var channelName in availableChannels) {
                    var channel = availableChannels[channelName];
                    var splitPath = channel.property.split('.');
                    var property = _profile[splitPath[0]] ? _profile[splitPath[0]].properties[splitPath[1]] : undefined;
                    if (property && property.value && ((typeof property.value === 'object' && Object.keys(property.value).length !== 0) || typeof property.value !== 'object')) {
                        channel.available = true;
                    }
                }



            },
            buildProfile: function(newProfile, profileTemplate){
                _allowOtherProperties = typeof profileTemplate._allowOtherProperties === "boolean" ? profileTemplate._allowOtherProperties : _allowOtherProperties;
                var profile = angular.copy(newProfile);
                profileTemplate = angular.copy(profileTemplate);
                for(var propertyGroupName in profileTemplate.schema){
                    var propertyGroup = profileTemplate.schema[propertyGroupName];
                    for(var propertyName in propertyGroup.properties){
                        var property = propertyGroup.properties[propertyName];
                        var path = [];
                        if(!propertyGroup.noPath && !property.internalPath){
                            path.push(propertyGroup.path);
                            path.push(propertyName);
                        }
                        else if(property.internalPath){
                            path = path.concat(property.internalPath.split("."));
                        }
                        else{
                            path.push(propertyName);
                        }
                        var tempProfile = profile;
                        for(var stepIndex in path){
                            var step = path[stepIndex];
                            if(!tempProfile){
                                break;
                            }
                            tempProfile = tempProfile[step];
                        }
                        if(property.type == "boolean" || (tempProfile && (typeof tempProfile !== 'object' || (typeof tempProfile === 'object' && (property.accessible || property.type ===  "displayableObject"))))){
                            property.value = tempProfile;
                        }
                        if(path.length == 1 && (profile[path[0]] || property.type == "boolean")){
                            delete profile[path[0]];
                        }
                        else if(path.length > 1 && profile[path[0]] && (profile[path[0]][path[1]] || property.type == "boolean")){
                            delete profile[path[0]][path[1]];
                            if(Object.keys(profile[path[0]]).length === 0){
                                delete profile[path[0]];
                            }
                        }
                    }
                }
                if(fac.allowOtherProperties()){
                    for(var propertyName in profile){
                        var property = profile[propertyName];
                        if(typeof property === 'object'){
                            var tempProperty;
                            if(!profileTemplate.schema[propertyName]){
                                tempProperty = {
                                    label: stripLabel(propertyName),
                                    logo: "./assets/img/icons/syg.png",
                                    properties: {},
                                    path: propertyName
                                };
                            }
                            else if(profileTemplate.schema[propertyName].templateLocked || propertyName.startsWith('_')){
                                continue;
                            }
                            else{
                                tempProperty = profileTemplate.schema[propertyName];
                            }
                            for(var subPropertyName in property){
                                if(!subPropertyName.startsWith('_')){
                                    tempProperty.properties[subPropertyName] = {
                                        label: stripLabel(subPropertyName),
                                        type: predictType(property[subPropertyName]),
                                        value: property[subPropertyName]
                                    };
                                }
                            }
                            if(!profileTemplate.schema[propertyName] && Object.keys(tempProperty.properties).length){
                                profileTemplate.schema[propertyName] = tempProperty;
                            }
                        }
                        else{
                            profileTemplate.schema.customProperties.properties[propertyName] = {
                                label: stripLabel(propertyName),
                                value: property,
                                type: predictType(property)
                            };
                        }
                    }
                }
                _profile = profileTemplate.schema;
                //availability of channels (opt in / opt out)
                fac.setAvailableChannels();
                return _profile;
            },
            getProfileData: function(configuredProfile, oldProfile) {
                var profileData = {};
                var emptyProperties = []

                for (var sectionName in configuredProfile) {
                    var section = configuredProfile[sectionName];
                    var oldSection = oldProfile ? oldProfile[sectionName] : {};

                    if (section.noPath) {
                        for (var propertyName in section.properties) {
                            var property = section.properties[propertyName];
                            var oldProperty = oldSection ? oldSection.properties[propertyName] : {};
                            //checking if any change or property is locked for changes
                            if(oldProperty.value !== property.value && (validProperty(property.value) || validProperty(oldProperty.value)) && !property.locked && !property.hidden){
                                if (validProperty(property.value)) {
                                    profileData[trim(propertyName)] = property.value;
                                } else if(property.value === "") {
                                    emptyProperties.push(trim(propertyName));
                                }
                            }
                        }
                    } else {
                        var newProperty = {};
                        var anyChange = false;
                        for (var propertyName in section.properties) {
                            var path = sectionName + "." + trim(propertyName);

                            var property = section.properties[propertyName];
                            var oldProperty = oldSection ? oldSection.properties[propertyName] : {};

                            //checking if any change
                            if(oldProperty.value !== property.value && (validProperty(property.value) || validProperty(oldProperty.value)) && !property.locked && !property.hidden){
                                if (validProperty(property.value)) {
                                    if(property.internalPath){
                                        profileData[property.internalPath] = property.value;
                                    }
                                    else{
                                        if (!property.locked && !property.hidden && !anyChange) {
                                            anyChange = true;
                                        }
                                        newProperty[trim(propertyName)] = property.value;
                                    }
                                } else if(property.value === "") {
                                    if(property.internalPath){
                                        emptyProperties.push(property.internalPath);
                                    } else {
                                        emptyProperties.push(path);
                                    }
                                }
                            }
                        }
                        if (anyChange) {
                            profileData[trim(sectionName)] = newProperty;
                        }
                    }
                }
                return {
                    dataToPatch: profileData,
                    emptyProperties: emptyProperties
                };
            },
            outOfCounter: function(property){
                if(!property || !property.value || !property.countTo) return true;
                var counterValue = moment(property.value);
                var countTo = property.countTo.split(":");
                for(var index in countTo){
                    counterValue.add(countTo[index].slice(0,2), countTo[index].slice(2,3));
                }

                if(counterValue.diff(moment()) < 0){
                    return true;
                }
                return false
            }
        };

        return fac;
    }]);
})(window.angular);